module.exports = __webpack_public_path__ + "static/img/qt.39cf70b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/qt.png
// module id = 1079
// module chunks = 1